import axiosInstance from './axiosConfig';

type ApiEnvelope<T> = {
  status: string;
  code: number;
  message: string;
  data: T;
  errors?: string[];
};

export type EmailVerificationStatus = {
  email: string;
  verified: boolean;
  expiresAt: string | null;
  verifiedAt: string | null;
};

export const emailVerificationService = {
  async sendLink(email: string): Promise<{ message: string; expiresAt: string | null }> {
    const response = await axiosInstance.post<ApiEnvelope<{ email: string; expiresAt: string | null }>>(
      '/auth/email-verification/send-link',
      { email }
    );
    return {
      message: response.data?.message || 'Verification email sent',
      expiresAt: response.data?.data?.expiresAt ?? null
    };
  },

  async confirmToken(token: string): Promise<{ message: string }> {
    const response = await axiosInstance.post<ApiEnvelope<{ verified: boolean }>>(
      '/auth/email-verification/confirm',
      { token }
    );
    return { message: response.data?.message || 'Email verified successfully' };
  },

  async getStatus(email: string): Promise<EmailVerificationStatus> {
    const response = await axiosInstance.get<ApiEnvelope<EmailVerificationStatus>>(
      '/auth/email-verification/status',
      { params: { email } }
    );
    return response.data?.data || {
      email,
      verified: false,
      expiresAt: null,
      verifiedAt: null
    };
  }
};
